import BreadCrumb from '../../../../components/Breadcrumb/breadCrumb'
import * as requiredUrls from '../../../../utils/appointment.url'
import {
  Loading,
  Dialog
} from 'element-ui'
import {
  wxQrcodeCreate,
  interOutnetConfig,
  supplementUpdate,
  getControlInfoByBusSeq
} from '@/utils/appointment.url.js' 
export default {
    data: function () {
        return {
            success: 0,
            hallName: this.$route.query.hallName,
            bsSeq: this.$route.query.bsSeq,
            date: this.$route.query.appointmentInfo.date,
            code: this.$route.query.appointmentInfo.code,
            week: this.$route.query.appointmentInfo.week,
            matterSeq: this.$route.query.matterSeq,
            endTime: this.$route.query.appointmentInfo.endTime,
            beginTime: this.$route.query.appointmentInfo.beginTime,
            codeUrl: '',
            dataList: [],
            is_show: false,
            current: null,
            searchValue: '',
            avgTime: this.$route.query.avgTime || '',// 平均时间
            aiShow: this.$route.query.appointmentInfo.aiShow,// 是否补充信息，0：显示，1：不显示
            extentedType:this.$route.query.extentedType,//晓屋标识
        }
    },
    components: {
        BreadCrumb,
      },
    watch: {
        searchValue : function () {
            return this.getControllnfoByBusSeq();
        }
    },
    methods: {
        Mouseover (item,index) {
            console.log(index);
            this.current =  index;   
        }, 
        Mouseleave (item,index) {
            this.current =  null;   
        },
        // 获取办件列表
        getControllnfoByBusSeq () {
            getControlInfoByBusSeq({
                approveSeq: this.matterSeq,
                busSeq: this.bsSeq,
                controlSeq: this.searchValue
            },
              'get'
        ).then(res => {
              if ( +res.status == 200) {
                  this.dataList = res.data;
              } else {
                  console.log(res)
                  
              }             
            }).catch(err => {
              console.log(err)
            })
            
        },
        // 点击搜索
        clickList (item) {
            this.is_show = false;
            this.searchValue = item.controlSeq;
        },
        Mousedown () {
            event.preventDefault();
        },
        // 提交
        clickSubmit () {
            if (this.searchValue == '') {                 
                return this.$message.error('办件编号不能为空！');
            }
            supplementUpdate({
                seq: this.code,
                controlSeq: this.searchValue
            },
              'post'
        ).then(res => {
              if ( +res.status == 200) {
                  this.$message.success('提交成功')
              } else {
                  console.log(res)
                  this.$message.error('提交成功')
              }             
            }).catch(err => {
              console.log(err)
            })
        },
        // 我的预约
        goMyAppointMent () {
            this.$router.push({
                path: '/myAppointMent',
                query: {
                  
                }
              })    
        },
        // 获取业务绑定事项列表数据
        getMatterList (item) {
            interOutnetConfig({
                    key: 'HALL_WX_QRCODE'
                },
                  'get'
                ).then(res => {
                  if ( +res.status == 200) {
                      // base64解码
                      //有配置时显示
                      if(res.data.value) {                       
                        this.codeUrl = window.atob(res.data.value);
                      }else {
                        //未配置时不展示
                        this.codeUrl = false
                      }                   
                  } else {
                      console.log(res)
                      
                  }
                  
                }).catch(err => {
                  console.log(err)
                })
        },
        backToIndex(){
          location.href = 'https://www.gdzwfw.gov.cn/';
        }
       
    },
    mounted () {
       this.getMatterList();
       this.getControllnfoByBusSeq();
       console.log(this.$route.query.appointmentInfo);
       // test
       this.aiShow = 0;
    },  
}
